<template>
  <q-page padding>
    <q-card class="md-card q-mt-lg q-pa-lg relative-position" color="white" text-color="black">
      <q-card-title>
        <h4>End-User License Agreement (EULA) of <span class="app_name">AGC MN</span></h4>
      </q-card-title>
      <q-card-separator/>
      <q-card-main>
        <div class="row">
          <div class="col-sm-12 l-lg-pad r-lg-pad">
            <p>This End-User License Agreement ("EULA") is a legal agreement between you and <span class="company_name">Associated General Contractors of Minnesota (AGC-MN)</span>
            </p>

            <p>This EULA agreement governs your acquisition and use of our <span class="app_name">AGC MN</span> software
              ("Software") directly from <span
                class="company_name">AGC-MN</span> or indirectly through a
              <span class="company_name">AGC-MN</span> authorized reseller
              or distributor (a "Reseller").</p>

            <p>Please read this EULA agreement carefully before completing the installation process and using the <span
              class="app_name">AGC MN</span> software. It provides a license to use the <span
              class="app_name">AGC MN</span> software and contains warranty information and liability disclaimers.</p>

            <p>If you register for a free trial of the <span class="app_name">AGC MN</span> software, this EULA
              agreement will also govern that trial. By clicking "accept" or installing and/or using the <span
                class="app_name">AGC MN</span> software, you are confirming your acceptance of the Software and agreeing
              to become bound by the terms of this EULA agreement.</p>

            <p>If you are entering into this EULA agreement on behalf of a company or other legal entity, you represent
              that you have the authority to bind such entity and its affiliates to these terms and conditions. If you
              do not have such authority or if you do not agree with the terms and conditions of this EULA agreement, do
              not install or use the Software, and you must not accept this EULA agreement.</p>

            <p>This EULA agreement shall apply only to the Software supplied by <span class="company_name">AGC-MN</span>
              herewith regardless of whether other software is referred to or described herein. The terms also apply to
              any <span class="company_name">AGC-MN</span> updates,
              supplements, Internet-based services, and support services for the Software, unless other terms accompany
              those items on delivery. If so, those terms apply.</p>

            <h5>License Grant</h5>

            <!--<p><span class="app_name">AGC MN</span> is a custom built application for AGC-MN exclusively. Only AGC-MN is-->
              <!--permitted to use this integration with Quickbooks. </p>-->

            <p><span class="company_name">AGC-MN</span> hereby grants you
              a personal, non-transferable, non-exclusive licence to use the <span class="app_name">AGC MN</span>
              software on your devices in accordance with the terms of this EULA agreement.</p>

            <p>You are permitted to load the <span class="app_name">AGC MN</span> software (for example a PC, laptop,
              mobile or tablet) under your control. You are responsible for ensuring your device meets the minimum
              requirements of the <span class="app_name">AGC MN</span> software.</p>

            <p>You are not permitted to:</p>

            <ul>
              <li>Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the Software nor
                permit the whole or any part of the Software to be combined with or become incorporated in any other
                software, nor decompile, disassemble or reverse engineer the Software or attempt to do any such things
              </li>
              <li>Reproduce, copy, distribute, resell or otherwise use the Software for any commercial purpose</li>
              <li>Allow any third party to use the Software on behalf of or for the benefit of any third party</li>
              <li>Use the Software in any way which breaches any applicable local, national or international law</li>
              <li>Use the Software for any purpose that <span class="company_name">AGC-MN</span>
                considers is a breach of this EULA agreement
              </li>
            </ul>

            <h5>Intellectual Property and Ownership</h5>

            <p><span class="company_name">AGC-MN</span> shall at all times
              retain ownership of the Software as originally downloaded by you and all subsequent downloads of the
              Software by you. The Software (and the copyright, and other intellectual property rights of whatever
              nature in the Software, including any modifications made thereto) are and shall remain the property of
              <span class="company_name">AGC-MN</span>.</p>

            <p><span class="company_name">AGC-MN</span> reserves the right
              to grant licences to use the Software to third parties.</p>

            <h5>Termination</h5>

            <p>This EULA agreement is effective from the date you first use the Software and shall continue until
              terminated. You may terminate it at any time upon written notice to <span
                class="company_name">AGC-MN</span>.
            </p>

            <p>It will also terminate immediately if you fail to comply with any term of this EULA agreement. Upon such
              termination, the licenses granted by this EULA agreement will immediately terminate and you agree to stop
              all access and use of the Software. The provisions that by their nature continue and survive will survive
              any termination of this EULA agreement.</p>

            <h5>General Terms and Conditions</h5>

            <p>You agree that use of the <span class="app_name">AGC MN</span> is at your sole risk. <span
              class="app_name">AGC MN</span> app is provided as an “as is” and “as
              available” basis. You agree that use of the Service, including any applets, software, content and services
              accessible therein, is entirely at your own risk.</p>

            <p><span class="company_name">AGC-MN</span> does not warrant that the service is free from bugs, viruses,
              errors, or other
              program limitations, nor does <span class="company_name">AGC-MN</span> warrant access to the Internet or
              to any other service
              or content through <span class="app_name">AGC MN</span>.</p>

            <p>The entire liability of <span class="company_name">AGC-MN</span> for any reason
              shall be limited to the amount paid by the customer for the related services or content purchased from
              <span class="company_name">AGC-MN</span>, its authorized reseller or its service providers.</p>

            <p>To the maximum extent permitted by applicable law, <span class="company_name">AGC-MN</span> and its
              subsidiaries, affiliates,
              licensors, participating financial institutes, third-party content or service providers, distributors,
              dealers or suppliers (“Representatives”) are not liable for any indirect, special, incidental, or
              consequential damages (including, but not limited to, damages for loss of business, loss of profits or
              investment, or the like), whether based on breach of warranty, tort (including negligence), product
              liability or otherwise, even if <span class="company_name">AGC-MN</span> or its representatives have been
              advised of the
              possibility of such damages, and even if a remedy set forth herein is found to have failed of its
              essential purpose.</p>

            <p><span class="company_name">AGC-MN</span>’ total liability related to or arising out of this agreement
              shall be limited to the
              amount of fees actually paid by you to <span class="company_name">AGC-MN</span> in the 12 months prior to
              the event causing
              any such liability.</p>

            <p>Some states do not allow the limitation and/or exclusion of liability for incidental or consequential
              damages, so the above limitation or exclusion may not apply to you.</p>

            <p>The limitations of damages set forth above are fundamental elements of the basis of the bargain between
              <span class="company_name">AGC-MN</span> and you. <span class="company_name">AGC-MN</span> would not be
              able to have provided this Service to you
              without such limitations.</p>

            <p>You agree that <span class="company_name">AGC-MN</span> has the right to collect, store, and use
              non-sensitive data that can
              be uniquely identified to a particular account and otherwise sensitive data that will be anonymized and
              aggregated.</p>

            <p>You agree that <span class="company_name">AGC-MN</span> may use your name and logo to identify you as a
              <span class="company_name">AGC-MN</span>
              customer on its website or in other sales or marketing materials (provided that <span
                class="company_name">AGC-MN</span> will
              not issue any press release regarding your use of the <span class="app_name">AGC MN</span> without your
              prior consent).</p>

            <h5>Governing Law</h5>

            <p>This EULA agreement, and any dispute arising out of or in connection with this EULA agreement, shall be
              governed by and construed in accordance with the laws of <span class="country">US</span>.</p>

          </div>
        </div>
      </q-card-main>
    </q-card>
    <router-view></router-view>
  </q-page>
</template>

<script>
export default {
  name: 'EULA'
}
</script>

<style></style>
